import { useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { getHostInfo } from "utils/networking"

const Logout = () => {
  const { logout } = useAuth0()
  const { logoutUrl } = getHostInfo()

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await logout({
          logoutParams: {
            returnTo: logoutUrl,
          },
        })
      } catch (error) {
        console.error("Logout failed:", error)
      }
    }

    handleLogout()
  }, [logout, logoutUrl])

  return null
}

export { Logout }
